var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.count > 0),expression:"count > 0"}],staticClass:"pull-right label label-danger"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }